import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../../../../components/Layout/Header/Header";
import Footer from "../../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../../components/Common/ScrollTop";
import OffWrap from "../../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../../components/Common/Breadcumb";
import SearchModal from "../../../../components/Layout/Header/SearchModal";
import footerLogo from "../../../../assets/img/logo/jntua-logo.png";
import { fetchData, imageBaseURL } from "../../../../utils/fetchData";
import Accreditation from "../../../../components/Common/Accreditation";
import { useFontSize } from "../../../../FontSizeContext";
import {
    getAPIPath,
    getMenu
} from "../../../../utils/getDomainData";
import Slider from "react-slick";
import { BlocksRenderer } from "../../../../components/BlockRenderer";

const OTPRIHomeMain = () => {
    const [data, setData] = useState([]);
    let location = useLocation();
    const currentDomain = location.pathname.split("/")[1];

    const { fontSize } = useFontSize();

    const [autoplaySpeed, setAutoplaySpeed] = useState(20000);
    const sliderRef = useRef(null);

    const sliderSettings = {
        dots: false,
        centerMode: false,
        autoplay: true,
        autoplaySpeed: autoplaySpeed,
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        beforeChange: (current, next) => {
            if (next === 0) {
                setAutoplaySpeed(20000);
            }
            if (next === 1) {
                setAutoplaySpeed(25000);
            }
            if (next === 2) {
                setAutoplaySpeed(36000);
            }
            if (next === 3) {
                setAutoplaySpeed(42000);
            } else {
                setAutoplaySpeed(30000);
            }
        },
    };

    useEffect(() => {
        fetchData(getAPIPath(currentDomain)?.home, setData);
    }, [currentDomain]);

    const otpriData = data?.data?.attributes;

    // Function to render rich text content
    const renderRichText = (content) => {
        if (!content || !Array.isArray(content)) return null;
        
        return content.map((block, index) => {
            if (block.type === 'paragraph') {
                return (
                    <p key={index} className="mb-3">
                        {block.children?.map((child, childIndex) => {
                            if (child.type === 'text') {
                                return <span key={childIndex}>{child.text}</span>;
                            }
                            return null;
                        })}
                    </p>
                );
            }
            return null;
        });
    };

    return (
        <React.Fragment>
            <Helmet>
                <title>JNTUA Oil Technological & Pharmaceutical Research Institute | JNTU Anantapur</title>
                <meta
                    name="description"
                    content="JNTUA Oil Technological and Pharmaceutical Research Institute (OT&PRI) - Providing top class pharmaceutical education in rural areas of Rayalaseema."
                />
                <meta
                    name="keywords"
                    content="OTPRI, Oil Technological, Pharmaceutical Research Institute, JNTUA, Pharmacy, M.Pharm, B.Pharm, Pharm.D, Anantapur"
                ></meta>
            </Helmet>
            <OffWrap />
            <Header
                parentMenu="home"
                TopBar="enable"
                TopBarClass="topbar-area dark-primary-bg hidden-lg"
            />
            <style>
                {`
                    body,
                    .rs-latest-events.style1 .event-wrap .events-short .date-part .date,
                    .widget ul li a {
                        font-size: ${fontSize}px;
                    }
                    .rs-inner-blog .blog-item .blog-content .blog-title,
                    .widget h1,.content-wrapper h2, .heading, .college-title{
                        font-size: calc(${fontSize}px + 10px);
                    }
                    .breadcrumb-bg .breadcrumbs-text ul li{
                      font-size: calc(${fontSize}px + 2px);
                    }
                    
                    .full-width-header .rs-header .topbar-area .topbar-right li.login-register a,
                    .readon.orange-btn, .rs-latest-events.bg-wrap .notification-filter button,
                    .rs-latest-events.style1 .event-wrap:not(.ls-area) .events-short .slNo, 
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > a,
                    .full-width-header .rs-header .menu-area .main-menu .rs-menu ul.nav-menu li.rs-mega-menu .mega-menu .single-megamenu .sub-menu > li > ul li > a,
                    table th, table td {                       
                        font-size: calc(${fontSize}px - 2px);
                    }

                    .rs-footer .footer-top-social .social_msg{
                        font-size: calc(${fontSize}px + 18px);
                    }
                    .rs-footer .footer-center h3{
                        font-size: calc(${fontSize}px + 12px);
                    }
                    .rs-footer.home9-style .footer-top .widget-title,
                    .rs-team.style1 .about-btn--primary,
                    .rs-team.style1 .about-btn--secondary,
                    .course-overview .inner-box h5{
                        font-size: calc(${fontSize}px + 4px);
                    }
                    .rs-footer .footer-center h4,
                    .rightBar h4{
                        font-size: calc(${fontSize}px + 6px);
                    }
                    .otpri-section {
                        padding: 40px 0;
                    }
                    .otpri-intro {
                        background: #f8f9fa;
                        padding: 40px 0;
                    }
                    .sections-content {
                        padding: 50px 0;
                    }
                    .section-card {
                        background: #fff;
                        border-radius: 10px;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                        padding: 30px;
                        margin-bottom: 30px;
                        height: 100%;
                        border-left: 4px solid #007bff;
                    }
                    .section-card h3 {
                        color: #007bff;
                        margin-bottom: 20px;
                        border-bottom: 3px solid #007bff;
                        padding-bottom: 10px;
                    }
                    .section-card.vision {
                        border-left-color: #28a745;
                    }
                    .section-card.vision h3 {
                        color: #28a745;
                        border-bottom-color: #28a745;
                    }
                    .section-card.mission {
                        border-left-color: #dc3545;
                    }
                    .section-card.mission h3 {
                        color: #dc3545;
                        border-bottom-color: #dc3545;
                    }
                    .section-card.policy {
                        border-left-color: #ffc107;
                    }
                    .section-card.policy h3 {
                        color: #ffc107;
                        border-bottom-color: #ffc107;
                    }
                    .section-card.welcome {
                        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
                        color: white;
                        border-left: none;
                        border-radius: 15px;
                        padding: 40px;
                        position: relative;
                        overflow: hidden;
                        box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
                    }
                    .section-card.welcome::before {
                        content: '';
                        position: absolute;
                        top: -50%;
                        right: -50%;
                        width: 100%;
                        height: 100%;
                        background: rgba(255, 255, 255, 0.1);
                        border-radius: 50%;
                        transform: rotate(45deg);
                    }
                    .section-card.welcome h3 {
                        color: white;
                        border-bottom: 3px solid rgba(255, 255, 255, 0.3);
                        font-size: 1.8rem;
                    }
                    .section-card.welcome .section-content {
                        font-size: 1.1rem;
                        line-height: 1.7;
                    }
                    .section-card.welcome .section-content p {
                        margin-bottom: 1.2rem;
                    }
                    .image-scroller {
                        display: flex;
                        overflow-x: auto;
                        gap: 20px;
                        padding: 20px 0;
                    }
                    .scroller-image {
                        min-width: 300px;
                        height: 200px;
                        border-radius: 10px;
                        overflow: hidden;
                        box-shadow: 0 5px 15px rgba(0,0,0,0.1);
                    }
                    .scroller-image img {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }
                    
                `}
            </style>
            <div className="pageTopOffset rs-slider main-home">

                {/* Image Scroller */}
                {otpriData?.imageScroller?.data && otpriData.imageScroller.data.length > 0 && (
                    <Slider {...sliderSettings} ref={sliderRef}>
                        {otpriData.imageScroller.data.map((image, index) => (
                            <div key={index}>
                                <div className="slider-content">
                                    <div className="bgMedia">
                                        <img src={`${imageBaseURL}${image.attributes.url}`}
                                            alt={image.attributes.alternativeText || "JNTUA OT&PRI"}
                                        />
                                    </div>
                                    <div className="fixedBannerTitle">
                                        <div className="container">
                                            <div className="content-part">
                                                <h2 className="sl-title">
                                                    Oil Technological & Pharmaceutical Research Institute
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </Slider>
                )}

                {getMenu(currentDomain)}

                {/* Sections Content */}
                <div className="sections-content">
                    <div className="container">
                        {otpriData?.sections && otpriData.sections.length > 0 && (
                            <div className="row">
                                {otpriData.sections.map((section, index) => {
                                    let cardClass = "section-card";
                                    
                                    // Special design for the first card (Welcome)
                                    if (index === 0 || section.title.toLowerCase().includes("welcome")) {
                                        cardClass += " welcome";
                                    }
                                    else if (section.title.toLowerCase().includes("vision")) cardClass += " vision";
                                    else if (section.title.toLowerCase().includes("mission")) cardClass += " mission";
                                    else if (section.title.toLowerCase().includes("policy")) cardClass += " policy";

                                    // Make welcome card full width
                                    const colClass = (index === 0 || section.title.toLowerCase().includes("welcome")) 
                                        ? "col-lg-12 col-md-12 mb-4" 
                                        : "col-lg-6 col-md-12 mb-4";

                                    return (
                                        <div key={section.id} className={colClass}>
                                            <div className={cardClass}>
                                                <h3>{section.title}</h3>
                                                <div className="section-content">
                                                    {renderRichText(section.content)}
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>

              

              

            </div>

            <Accreditation />

            <Footer
                footerClass="rs-footer home9-style main-home"
                footerLogo={footerLogo}
            />

            {/* scrolltop-start */}
            <ScrollToTop scrollClassName="scrollup orange-color" />
            {/* scrolltop-end */}

            <SearchModal />
        </React.Fragment>
    );
};

export default OTPRIHomeMain;